import React from 'react';
import { Button } from '@/components/ui/button';
import { Instagram } from 'lucide-react';

interface NewsletterSignupSectionProps {
  onSignupClick: () => void;
}

const NewsletterSignupSection = ({ onSignupClick }: NewsletterSignupSectionProps) => {
  return (
    <div className="bg-[rgb(var(--newsletter-gray))] -mx-6 md:mx-0 mb-0">
      <div className="px-6 md:px-8 pt-8 pb-6 md:py-8">
        <div className="text-left md:text-center">
          <h1>Få informationen direkt i din inkorg</h1>
          <p className="text-[16px] font-satoshi mb-6">
            Prenumerera på vårt nyhetsbrev och följ oss på instagram för info om nya föreställningar och kurser.
          </p>
          <div className="flex flex-wrap gap-3 md:justify-center">
            <Button
              variant="default"
              className="min-h-10 px-4 w-auto"
              asChild
            >
              <a href="https://www.instagram.com/lillaimproteatern/" target="_blank" rel="noopener noreferrer">
                <Instagram className="h-4 w-4" />
                <span>Följ oss</span>
              </a>
            </Button>
            <Button 
              onClick={onSignupClick}
              variant="default"
              className="min-h-10 px-4 w-auto"
            >
              <span>Skriv upp dig</span>
              <span className="text-2xl font-bold">→</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterSignupSection;